import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/api/api";

// GET — oddiy, chunki kamroq xato bo‘ladi
export const fetchRoles = createAsyncThunk(
  "adminApis/fetchRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/roles");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// POST — create role
export const createRole = createAsyncThunk(
  "adminApis/createRole",
  async (roleData, { rejectWithValue }) => {
    try {
      const response = await api.post("/admin/role/create", roleData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// PUT — update role
export const updateRole = createAsyncThunk(
  "adminApis/updateRole",
  async ({ roleId, roleData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/role/${roleId}`, roleData);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// POST — add role to user
export const addRoleToUser = createAsyncThunk(
  "adminApis/addRoleToUser",
  async ({ userId, roleId }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/admin/user/${userId}/roles/${roleId}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// DELETE — remove role from user
export const removeRoleFromUser = createAsyncThunk(
  "adminApis/removeRoleFromUser",
  async ({ userId, roleId }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/admin/user/${userId}/roles/${roleId}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// GET USERS BY ROLE ID
export const fetchUsersByRoleId = createAsyncThunk(
  "adminApis/fetchUsersByRoleId",
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/roles/${roleId}/users`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// USERS LIST
export const fetchUsers = createAsyncThunk(
  "adminApis/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/users");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// GET USER DETAIL
export const fetchUserDetail = createAsyncThunk(
  "adminApis/fetchUserDetail",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/users/${userId}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// GET ALL USERS WITH STATISTICS
export const fetchUsersWithStatistics = createAsyncThunk(
  "adminApis/fetchUsersWithStatistics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/users/statistics");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);

// GET USER DETAILED STATISTICS
export const fetchUserStatistics = createAsyncThunk(
  "adminApis/fetchUserStatistics",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/users/${userId}/statistics`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.message || err.message);
    }
  }
);